import React from "react";
import ObserverEmitter, { EVENTS } from "../../emitter/Observer";
import { audiosAssets } from "../../assets/audio";

export const ModalInfoTextV2 = ({ children, callback, description = "", title = "", btnText = "Continuar", url = "" }) => {
	return (
		<div className="fixed w-full h-full bg-[#00000074] flex justify-center items-center animate__animated  animate__fadeIn">
			<div className="w-[596px] h-[247px] md:w-[874px] md:h-[384px] rounded-[24px] md:rounded-[32px] bg-[#F2F2F2] p-4 md:p-6 overflow-hidden">
				<div className="w-full h-[38px] md:h-[60px]">
					<div className="w-full h-[20px] md:h-[40px] bg-red_primary rounded-[4px] flex justify-center items-center">
						<p className="text-white text-[14px] md:text-[20px]">{title}</p>
					</div>
				</div>
				<div className="w-full h-[calc(100%-38px)] md:h-[calc(100%-60px)] flex">
					<div className="h-full w-[142px] md:w-[224px]  rounded-[16px] overflow-hidden">
						<div className="h-full w-full">
							<img src={url} className="w-full h-full" alt=""></img>
						</div>
					</div>
					<div className="w-[calc(100%-142px)] md:w-[calc(100%-224px)] h-full">
						<div className="w-full h-[calc(100%-35px)] md:h-[calc(100%-45px)] px-4 md:px-12 overflow-y-scroll hidden-scrooll">
							{description !== "" ? (
								<p className="text-[12px] md:text-[16px]">
									{description}
								</p>
							) : (
								<>
									{children}
								</>
							)}
						</div>
						<div className="w-full h-[35px] md:h-[45px] flex justify-center items-center overflow-hidden">
							<div onClick={() => {
								ObserverEmitter.emit(EVENTS.audiosEvents.createAudioActionButton, audiosAssets.barraNavegacion.completeNavigation)
								callback()
							}} className="w-[214px] md:w-[336px] h-[30px] md:h-[35px] bg-yellow_primary rounded-[10px] flex justify-center items-center boxShadowButtons">
								<p className="text-white font-bold text-[16px]">{btnText}</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};
